// extracted by mini-css-extract-plugin
export default {"actionBtn":"new-lga-modal_actionBtn__Fr0Xc","saveBtn":"new-lga-modal_saveBtn__q-OzJ","formInput":"new-lga-modal_formInput__CjlQs","instruction":"new-lga-modal_instruction__e5be6"};